import httpUtil from '../assets/script/utils/http'
import config from '../assets/script/config'

const state = {};

const mutations = {};


const actions = {
  AList(ctx, params) {
    return httpUtil.get("/WordCloud/Lists", params)
  },
  AGetFontList(ctx, params) {
    return httpUtil.get("/WordCloud/GetFontList", params)
  },
  AGetPatternList(ctx, params) {
    //params.pageSize = 50;
    return httpUtil.get("/pattern/PatternList", params)
  },
  AGetLabelList(ctx, params) {
    return httpUtil.get("/pattern/LabelList", params)
  },
  AGetWordFrequencyList(ctx, params) {
    return httpUtil.get("/NaoTu/Transit", params)
  },
  AGetPatternType() {
    return httpUtil.get("/Pattern/PatternType")
  },
  /**
   *插入任务
   * @returns {*|Promise}
   * @constructor
   */
  AInsert(ctx, params) {
    return httpUtil.post("/wordfrequency/search", params)
  },
  /**
   * 获取数据
   * @param ctx
   * @param params
   * @returns {*|Promise}
   * @constructor
   */
  AFrequency(ctx, params) {
    return httpUtil.get("/wordfrequency/data", params)
  },
  /**
   * 上传图片
   * @param ctx
   * @param params
   * @returns {*|Promise}
   * @constructor
   */
  AUploadPattern(ctx, params) {
    return httpUtil.get("/pattern/upload ", params)
  },
  /**
   * 生成
   * @param ctx
   * @param params
   * @constructor
   */
  AGenerate(ctx, params) {
    return httpUtil.post("/wordcloud/generate", params)
  },

  AgetImageTest(ctx, param) {
    return httpUtil.getNoHost(param);
  },

  /**
   * 分享
   * @param ctx
   * @param params
   * @constructor
   */
  AShare(ctx, params) {
    return httpUtil.post("/WordCloud/Share", params)
  },
  /**
   * 获取
   * @param ctx
   * @param params
   * @constructor
   */
  AGet(ctx, params) {
    return httpUtil.get("/WordCloud/detail", params)
  },
  /**
   * 点赞
   * @param ctx
   * @param params
   * @returns {*|Promise}
   * @constructor
   */
  ALike(ctx, params) {
    return httpUtil.post("/WordCloud/like", params)
  },
  ADownload(ctx, params) {
    window.open(`${config.host}/wordcloud/DownloadWordCloud?mainGuid=${params.mainGuid}`)
  },
  // 更新用户最近使用图片点击时间
  AUpdateClickTime(ctx, params) {
    return httpUtil.post("/pattern/click", params)
  },
  // 最近使用的清空
  AEmpty(ctx, params) {
    return httpUtil.post("/pattern/empty", params)
  },
  /**
   * 检查词云是否存在选题宝
   * @param ctx
   * @param params
   * @returns {*|Promise}
   * @constructor
   */
  AXtCheckName(ctx, params) {
    return httpUtil.post("/wordfrequency/checkname", params)
  },
};


export default {
  namespaced: true,
  state,
  mutations,
  actions
};
